/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
window.BoqDocumentVersion = {
  _boqId: null,
  _checkImportPath: null,

  checkImportInInterval() {
    return setInterval(_.bind(this._checkImport, this), 30000);
  },

  _checkImport() {
    return $.ajax({
      type: 'GET',
      url: this._checkImportPath,
      dataType: 'json',
      success(response) {
        if (response['success'] === true) {
          return window.location = response['redirect_link'];
        } else {
          return $('#importRow').removeClass('hidden');
        }
      }
      });
  },

  setupOnlyImportChecking(checkImportPath) {
    this._checkImportPath = checkImportPath;
    return this.checkImportInInterval();
  },

  setupImportForm(checkImportPath, boq_id) {
    this._checkImportPath = checkImportPath;
    this._boqId = boq_id;
    $('#submitImportButton').on('click', _.bind(this._submitImportForm, this));
    $('.cancelImport').on('click', _.bind(this._closeModalOrCancelImport, this));

    const $form = $('#submitImportButton').closest('form');
    const $statusBar = $('#currentStatus');
    return $form.submit(event => {
      $.ajax({
        xhr() {
          const xhr = new window.XMLHttpRequest();
          const handler = e => {
            if (e.lengthComputable) { return $statusBar.css('width', `${(e.loaded / e.total) * 100}%`); }
          };
          xhr.upload.addEventListener("progress", handler, false);
          return xhr;
        },
        type: 'POST',
        url: $form.attr('action'),
        data: new FormData($form[0]),
        cache: false,
        contentType: false,
        processData: false,
        dataType: 'json',
        beforeSend() { return $statusBar.show(); },
        success: _.bind(this._importCallHandler, this)
        });
      return event.preventDefault();
    });
  },

  _reloadPage() {
    return window.location.reload();
  },

  _closeModalOrCancelImport() {
    if ($(this)[0].id === 'resetForm') {
      return $(this).next().text('').parent().hide().closest('form')[0].reset();
    } else {
      return $('#import-modal').foundation('reveal', 'close');
    }
  },

  _importCallHandler(response) {
    $('#currentStatus').hide();
    if (response['success'] === true) {
      return this._reloadPage();
    } else {
      return this._errorMessageHandler(response);
    }
  },

  _errorMessageHandler(response) {
    $('#errorRow').removeClass('hidden').html(response['message']);
    $('#submitImportButton').closest('form')[0].reset();
    $('.cancelImport').removeClass('hidden');
    $('#fileButton').removeClass('disabled');
    return $('#submitImportButton').removeClass('disabled').text(I18n.t('submit'));
  },

  _submitImportForm() {
    $('.cancelImport').addClass('hidden');
    $('#submitImportButton').text(I18n.t('v4.boq_document_versions.finish')).addClass('disabled');
    $('#fileButton').addClass('disabled');
    return $('#submitImportButton').closest('form').submit();
  }

};
